import { render, staticRenderFns } from "./PurchaseOrderNew.vue?vue&type=template&id=b2b2ac94&"
import script from "./PurchaseOrderNew.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports